import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';

const MATERIAL_MODULES = [
  MatProgressBarModule,
];

@NgModule({
    imports: MATERIAL_MODULES,
    exports: MATERIAL_MODULES,
    providers: [{
        provide: ANIMATION_MODULE_TYPE,
        useValue: 'BrowserAnimations',
    }],
})
export class UiProgressBarModule { }
